module.exports = __webpack_public_path__ + "img/sberbank.c0fc9ed4.svg";